'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const ContentManager = require('./../component/ContentManager');
const menu = require('./../../../services/structure/menu');
const mediator = require('./../../../core/mediator');
const container = require('./../../../core/container');
const translator = require('./../../../core/translator');
const menuMobile = require('./../../../services/structure/menu/mobile');
const notifier = require('./../../../services/notifier');
const contentScroller = require('./../mobile/service/contentScroller');

let timeouts = [];

module.exports.removeHighlight = function() {
    jQuery('.cloud-highlight').removeClass('cloud-highlight cloud-highlight-bg');
};

const openMenu = function(content, callback) {
    let $menuWrapper = container.get('$toolbar').find('.cloud-nav-wrapper');
    let $btn = jQuery('<button class="btn btn-default btn-close-menu"></button>').text(translator.translate('discard'));

    menu.clear();

    if (0 === $menuWrapper.find('.btn-close-menu').length) {
        $btn.one('touchstart MSPointerDown', menuMobile.close);
        $menuWrapper.append($btn);
    }

    mediator.publish('plugins:menu', {
        'add': menu.add,
        'content': content,
    });

    content.$.addClass('cloud-highlight').one('touchstart.menu_close MSPointerDown.menu_close', function() {
        menuMobile.close();
    });

    if (content.$.css('background-color') === 'rgba(0, 0, 0, 0)') {
        content.$.addClass('cloud-highlight-bg');
    }

    $menuWrapper.addClass('cloud-menu-plugin');

    menuMobile.open(callback);
};

const isEditable = function(content) {
    let isEditable = -1 === require('./../config').settings.contents_not_editable.indexOf(content.type);

    if (false === content.$.data('mobile-edit')) {
        isEditable = false;
    }

    return isEditable;
};

const clearTimeouts = function() {
    _.forEach(timeouts, function(timeout) {
        clearTimeout(timeout);
    });

    timeouts = [];
};

const warnUneditableMobileContent = () => {
    notifier.warning(translator.translate('content_not_editable_mobile'));
};

module.exports.openMenu = openMenu;

module.exports.init = function() {
    jQuery('body').on('touchstart MSPointerDown', '.bb-content', function(event) {
        let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

        if (null !== content && isEditable(content) && false !== content.editable) {
            timeouts.push(setTimeout(function() {
                let parent = content.getParent();

                if (null !== parent && !parent.isContentSet() && false === parent.$.data('mobile-edit')) {
                    warnUneditableMobileContent();
                } else {
                    openMenu(content, function() {
                        contentScroller.scroll(content);
                    });
                }
            }, 350));
        }
    });

    jQuery('body').on('touchmove MSPointerMove', '.bb-content', function(event) {
        let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

        if (null !== content && isEditable(content) && false !== content.editable) {
            clearTimeouts();
        }
    });

    jQuery('body').on('touchend MSPointerUp', '.bb-content', function(event) {
        let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

        if (null !== content && isEditable(content) && false !== content.editable) {
            clearTimeouts();
        }
    });
};
